/* Bounded DOM enhancement; no catalog downloads, trackers, or persistent customer data. */
class SJStickyPurchase extends HTMLElement {
  connectedCallback() {
    this.bar = this.querySelector('.sj-sticky');
    this.trigger = this.querySelector('button');
    this.target = document.getElementById(this.dataset.target);
    if (!this.bar || !this.trigger || !this.target || !('IntersectionObserver' in window)) return;
    this.activate = () => {
      // Return to the current native product form so variant validation and app inputs stay authoritative.
      const form = document.getElementById(this.dataset.target);
      form?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
      form?.querySelector('button[name="add"]')?.focus({ preventScroll: true });
    };
    this.trigger.addEventListener('click', this.activate);
    this.observer = new IntersectionObserver(([entry]) => {
      this.bar.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
    }, { threshold: 0 });
    this.observer.observe(this.target);
  }
  disconnectedCallback() {
    this.observer?.disconnect();
    this.trigger?.removeEventListener('click', this.activate);
  }
}
if (!customElements.get('sj-sticky-purchase')) customElements.define('sj-sticky-purchase', SJStickyPurchase);

class SJArtworkGallery extends HTMLElement {
  connectedCallback() {
    this.filters = this.querySelector('.sj-place-filters');
    if (!this.filters) return;
    this.buttons = [...this.filters.querySelectorAll('[data-place]')];
    this.cards = [...this.querySelectorAll('[data-artwork-place]')];
    this.status = this.querySelector('[role="status"]');
    this.activate = (place, updateUrl = false) => {
      if (!this.buttons.some(button => button.dataset.place === place)) place = 'all';
      let count = 0;
      this.cards.forEach(card => { card.hidden = place !== 'all' && card.dataset.artworkPlace !== place; if (!card.hidden) count++; });
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.place === place)));
      this.status.textContent = this.dataset.countTemplate.replace('[count]', count);
      this.querySelector('.sj-gallery-empty').hidden = count > 0;
      if (updateUrl) {
        const url = new URL(location.href);
        if (place === 'all') url.searchParams.delete('place'); else url.searchParams.set('place', place);
        url.hash = this.id;
        history.replaceState(null, '', url);
        this.dispatchEvent(new CustomEvent('sj:discovery', { bubbles: true, detail: { place, count } }));
      }
    };
    this.click = event => { const button = event.target.closest('[data-place]'); if (button) this.activate(button.dataset.place, true); };
    this.restore = () => this.activate(new URL(location.href).searchParams.get('place') || 'all');
    this.filters.hidden = false;
    this.filters.addEventListener('click', this.click);
    window.addEventListener('popstate', this.restore);
    this.restore();
  }
  disconnectedCallback() {
    this.filters?.removeEventListener('click', this.click);
    window.removeEventListener('popstate', this.restore);
  }
}
if (!customElements.get('sj-artwork-gallery')) customElements.define('sj-artwork-gallery', SJArtworkGallery);
